import Axios from "axios";

export default {
    getAuditedCompanies(_) {
        return Axios.get('/api/auditor/getauditedcompanies', { withCredentials: true });
    },

    getAuditedCompanyInfo(_, id) {
        return Axios.get(`/api/auditor/getauditedcompanyinfo/${id}`, { withCredentials: true });
    },

    getMetricsMonitoringByCompanyId(_, params) {
        return Axios.post("/api/auditor/getmetricsmonitoringbycompanyid", params, { withCredentials: true })
    },

    getTotalMetricsMonitoringByCompanyId(_, params) {
        return Axios.post('/api/auditor/gettotalmetricsmonitoringbycompanyid', params, { withCredentials: true });
    },

    addMetricInputComment(_, params) {
        return Axios.post('/api/auditor/addmetricinputcomment', params, { withCredentials: true });
    },

    changeMetricStatus(_, params) {
        return Axios.post('/api/auditor/changemetricstatus', params, { withCredentials: true });
    },

    changeDocumentStatus(_, params) {
        return Axios.post('/api/auditor/changedocumentstatus', params, { withCredentials: true });
    },


    // get surveys //
    getSU1Surveys(_, params) {
        return Axios.post('/api/auditor/su1/getsurveys', params, { withCredentials: true })
    },

    getSU2Surveys(_, params) {
        return Axios.post('/api/auditor/su2/getsurveys', params, { withCredentials: true })
    },


    // get last survey //
    getLastSU1Survey(_, params) {
        return Axios.post('/api/auditor/su1/getlastsurvey', params, { withCredentials: true })
    },

    getLastSU2Survey(_, params) {
        return Axios.post('/api/auditor/su2/getlastsurvey', params, { withCredentials: true })
    },


    // text results //
    getTextsResultsByCompanyID(_, params) {
        return Axios.post('/api/su1result/gettextsresultsbycompanyid', params, { withCredentials: true })
    },

    getSU2SurveyResults(_, params) {
        return Axios.post('api/su2result/getsu2textresults', params, { withCredentials: true })
    },

    // company profile // 

    getFirstSection(_, params) {
        return Axios.post("/api/auditor/companyprofile/getfirstsectioninfo", params, {
            withCredentials: true,
        });
    },

    getSecondSection(_, params) {
        return Axios.post("/api/auditor/companyprofile/getsecondsectioninfo", params, {
            withCredentials: true,
        });
    },

    getAboutCompany(_, params) {
        return Axios.post("/api/auditor/companyprofile/getaboutcompany", params, {
            withCredentials: true,
        });
    },

    getFacilitySlotNumber(_, params) {
        return Axios.post("/api/auditor/companyprofile/getfacilityslotnumber", params, {
            withCredentials: true,
        });
    },

    getVisionMissionValues(_, params) {
        return Axios.post(
            `/api/auditor/companyprofile/getvisionmissionvalues/${params.type}`, params.body, { 
                withCredentials: true 
        });
    },

    // report //

    changeReportAuditStatus(_, params) {
        return Axios.post(
            `/api/auditor/changereportauditstatus`, params, {
                withCredentials: true
        });
    },

    updateReportAuditorComment(_, params) {
        return Axios.post(
            `/api/auditor/updatereportaudtorcomment`, params, {
                withCredentials: true
        });
    },

    // register //

    registerAsAuditor(_, params) {
        return Axios.post(
            `/api/auditor/createauditorcompany`, params, {
                withCredentials: true
            });
    },

    // audited company //

    getAuditorByAuditedCompany(_) {
        return Axios.get(
            `/api/auditor/getauditorbyauditedcompany`, {
                withCredentials: true
            });
    },

    getAuditorCompanies(_) {
        return Axios.get(
            `/api/auditor/getauditorcompanies`, {
                withCredentials: true
            });
    },

    changeAuditorCompany(_, params) {
        return Axios.post(
            `/api/auditor/changeauditorcompany`, params, {
                withCredentials: true
            });
    },
    
    createAuditorRelationRequest(_, params) {
        return Axios.post(
            `/api/auditor/send-auditor-request`, params, {
                withCredentials: true
            });
    },
    
    deleteAuditorRelationRequest(_, params) {
        return Axios.delete(
            `/api/auditor/delete-auditor-relation-request/${params.auditor_relation_request_id}`, {}, {
                withCredentials: true
            });
    },
    
    getAuditorRelationRequestsByAuditor(_) {
        return Axios.get(
            `/api/auditor/get-auditor-relation-requests`, {
                withCredentials: true
            });
    },

}